var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 2v20M6.553 2v20"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14.928,
  cy: 8.383,
  r: 5.633
})));
SvgLogo.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export default ForwardRef;